import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter } from "react-router-dom";
import "./index.css";
import WrapApp from "./WrapApp";
import reportWebVitals from "./reportWebVitals";

ReactDOM.render(
  <BrowserRouter>
    <WrapApp />
  </BrowserRouter>,
  document.getElementById("root")
);

reportWebVitals();
